<template>
	<b-modal title="Cambia Stato" ref="mdlCambiaStato" id="mdlCambiaStato" ok-title="Aggiorna" @shown="onShownCambiaStato" @ok="onOkCambiaStato">
		<b-row>
			<b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
				<label class="sa-label-data">Nuovo Stato:</label>
				<b-form-select v-model="jsonData.stato" :options="statoOptions" :value="''" value-field="stato" text-field="stato">
					<template #first>
						<b-form-select-option :value="null" disabled> - Seleziona Stato - </b-form-select-option>
					</template>
				</b-form-select>
			</b-col>
			<b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
				<label class="sa-label-data">Note:</label>
				<b-form-textarea v-model="jsonData.note" rows="7"></b-form-textarea>
			</b-col>
		</b-row>
	</b-modal>
</template>

<script>
import UtilityMixin from "../UtilityMixin";
export default {
	mixins: [UtilityMixin],
	data() {
		return {
			body: null,
			statoOptions: [],
			pathResource: null,
			pathResourceAggiornaStato: null,
			jsonData: { stato: null, note: null },
		};
	},
	methods: {
		show(body, pathResource, pathResourceAggiornaStato, elencoStati = []) {
			this.body = body;
			this.statoOptions = elencoStati;
			this.pathResource = pathResource;
			this.pathResourceAggiornaStato = pathResourceAggiornaStato;
			this.$refs.mdlCambiaStato.show();
		},
		loadData() {
			let me = this;
			UtilityMixin.methods.loadDataResources(me.pathResource, {}, me.loadDataSuccess, me.loadDataError);
		},
		loadDataSuccess(response) {
			console.log(response);
			this.statoOptions = response.data.data.list;
		},
		loadDataError(error) {
			console.log(error);
		},
		aggiornaStato() {
			let me = this;
			this.body.stato = me.jsonData.stato;
			this.body.note = me.jsonData.note;
			me.saveResource(me.pathResourceAggiornaStato, this.body, me.aggiornaStatoSuccess, me.aggiornaStatoError);
		},
		aggiornaStatoSuccess() {
			let me = this;
			this.numeroRecordsSalvati++;
			me.$bvToast.toast("Aggiornamento avvenuto con succedsso ", {
				title: "Elemento Associato",
				variant: "success",
				solid: true,
			});
			me.$emit("cambioStatoSuccess");
			me.closeModal();
		},
		aggiornaStatoError(error) {
			let me = this;
			this.numeroRecordsSalvati++;
			me.allSavedSuccess = false;
			let messaggio = error.response ? error.response.data.messaggio : error.message;
			me.$bvToast.toast("Errore nell'aggiornamento " + messaggio, {
				title: "Errore",
				variant: "danger",
				solid: true,
			});
			me.closeModal();
		},
		closeModal() {
			this.$refs.mdlCambiaStato.hide();
		},
		onShownCambiaStato() {
			if (this.pathResource) {
				this.loadData();
			}
		},
		onOkCambiaStato(bvModalEvent) {
			bvModalEvent.preventDefault();
			this.aggiornaStato();
		},
	},
};
</script>

<style></style>
